__turbopack_context__.v({
  "showAllAccessRequestsButton": "ShowAllAccessRequestsButton-module__u6lRZW__showAllAccessRequestsButton",
  "showAllAccessRequestsButtonContainer": "ShowAllAccessRequestsButton-module__u6lRZW__showAllAccessRequestsButtonContainer",
});
